import { apiClient } from './client'

export type FeatureFlag = {
  key: string
  name: string
  description: string
  category: string
  enabled: boolean
  defaultEnabled: boolean
  updatedAt?: string | null
  updatedBy?: string | null
}

export type UpdateFeatureFlagRequest = {
  enabled: boolean
}

export async function getFeatureFlags(): Promise<FeatureFlag[]> {
  const { data } = await apiClient.get<FeatureFlag[]>('/api/admin/feature-flags')
  return data
}

export async function updateFeatureFlag(
  key: string,
  payload: UpdateFeatureFlagRequest
): Promise<FeatureFlag> {
  const { data } = await apiClient.put<FeatureFlag>(
    `/api/admin/feature-flags/${encodeURIComponent(key)}`,
    payload
  )
  return data
}

